import type { enEmail } from '../en/email.js';

export const deEmail: Record<keyof typeof enEmail, string> = {
  'email.greeting': 'Guten Tag {guest},',
  'email.greeting_anon': 'Guten Tag,',
  'email.row.restaurant': 'Restaurant',
  'email.row.when': 'Wann',
  'email.row.party': 'Personen',
  'email.row.code': 'Reservierungsnummer',
  'email.party_one': '{n} Person',
  'email.party_other': '{n} Personen',
  'email.link.manage': 'Reservierung ansehen oder stornieren',
  'email.link.rebook': 'Neuen Termin buchen',
  'email.footer.contact': 'Fragen? {contact}',
  'email.footer.phone': 'Telefon: {phone}',
  'email.footer.email': 'E-Mail: {email}',
  'email.footer.address': 'Adresse: {address}',
  'email.footer.website': 'Webseite: {website}',
  'email.confirmation.subject': 'Ihre Reservierung bei {restaurant}: {when}',
  'email.confirmation.lead': 'Ihr Tisch ist bestätigt. Wir freuen uns auf Ihren Besuch.',
  'email.reminder.subject': 'Erinnerung: {restaurant}, {when}',
  'email.reminder.lead':
    'Wir erinnern Sie freundlich an Ihre Reservierung. Falls sich Ihre Pläne geändert haben, stornieren Sie bitte, damit wir den Tisch anderen Gästen anbieten können.',
  'email.change.subject': 'Ihre Reservierung bei {restaurant} wurde geändert',
  'email.change.lead': 'Ihre Reservierung wurde geändert. Unten finden Sie die aktuellen Angaben.',
  'email.cancellation.subject': 'Ihre Reservierung bei {restaurant} wurde storniert',
  'email.cancellation.lead': 'Ihre Reservierung wurde storniert. Es fallen keine Kosten an.',
  'email.cancellation.lead_fee': 'Ihre Reservierung wurde storniert. Gemäß den Stornierungsbedingungen fallen {fee} an.',
  'email.policy.deposit':
    'Es wurde eine Anzahlung von {amount} erhoben. Sie wird erstattet, wenn Sie mindestens {hours} Stunden vorher stornieren, und bei kurzfristiger Stornierung oder Nichterscheinen einbehalten.',
  'email.policy.card':
    'Ihre Karte ist hinterlegt, es wurde nichts abgebucht. Bei Nichterscheinen oder einer Stornierung innerhalb von {hours} Stunden können bis zu {amount} berechnet werden.',
  'sms.table_ready': '{restaurant}: Guten Tag {guest}, Ihr Tisch ist bereit. Bitte kommen Sie zum Empfang.',
  'sms.running_late': '{restaurant}: Guten Tag {guest}, wir halten Ihren Tisch frei. Bitte sagen Sie uns, wann Sie eintreffen.',
  'notify.new': 'Neue Reservierung von {guest}',
  'notify.cancelled': 'Stornierung von {guest}',
  "alert.subject": "{restaurant}: ein Tisch ist frei geworden",
  "alert.body": "Guten Tag {guest}, bei {restaurant} ist ein Tisch für {party} am {date} frei geworden. Jetzt buchen, bevor er weg ist:",
  "pr.subject_new": "Neue Anfrage für eine Veranstaltung von {guest}",
  "pr.subject_status": "{restaurant}: Ihre Anfrage für eine Veranstaltung",
  "pr.quoted": "Guten Tag {guest}, vielen Dank für Ihre Anfrage für den {date}. Unser Angebot: {amount}{deposit}. Antworten Sie auf diese E-Mail, um es anzunehmen.",
  "pr.confirmed": "Guten Tag {guest}, Ihre Veranstaltung am {date} ist bestätigt. Wir freuen uns auf Sie.",
  "pr.declined": "Guten Tag {guest}, leider können wir Ihre Veranstaltung am {date} nicht ausrichten. Vielen Dank, dass Sie an uns gedacht haben.",
  "pr.deposit": ", mit einer Anzahlung von {deposit}",
  "mk.unsub": "Sie erhalten diese Nachricht, weil Sie zugestimmt haben, von {restaurant} zu hören. Abmelden: {link}",
  'email.review.subject': 'Wie war Ihr Besuch bei {restaurant}?',
  'email.review.lead': 'Vielen Dank für Ihren Besuch bei {restaurant}. Wenn es Ihnen gefallen hat, hilft eine kurze Bewertung anderen Gästen, uns zu finden.',
  'email.link.review': 'Bewertung abgeben',
  'email.unsubscribe': 'Sie erhalten diese Nachricht, weil Sie zugestimmt haben, von uns zu hören. Abmelden: {link}',
  'p.list_title': 'Tagesliste',
  'p.cards_title': 'Tischkarten',
  'p.time': 'Zeit',
  'p.table': 'Tisch',
  'p.party': 'Pers.',
  'p.guest': 'Gast',
  'p.notes': 'Hinweise',
  'p.shift_notes': 'Schichtnotizen',
  'p.closed': 'Geschlossen',
  'p.parties': 'Gruppen',
  'p.covers': 'Gäste',
  'p.total': 'Gesamt',
  'p.none': 'Keine Reservierungen.',
  'p.legend': '[Karte] = Karte hinterlegt oder Anzahlung. Kästchen abhaken, wenn die Gruppe sitzt.',
  'p.card_name': 'Name des Gastes:',
  'p.card_mark': 'Karte',
  'p.daily_subject': '{restaurant}: Listen für {date}',
  'p.daily_body': 'Guten Morgen. Im Anhang: die Tagesliste und die Tischkarten für {date} ({parties} Reservierungen, {covers} Gäste).',
  'notify.when': 'Wann',
  'notify.party': 'Personen',
  'notify.code': 'Referenz',
  'notify.phone': 'Telefon',
  'notify.request': 'Wunsch',
  'notify.large': 'Dies ist eine große Gruppe.',
  'notify.subject_new': 'neue Reservierung, {guest}, {party} Personen',
  'notify.subject_cancel': 'Stornierung, {guest}, {party} Personen',
};
